import { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import TelaInicial from './pages/TelaInicial';
import Colaboradores from './pages/Colaboradores';
import Associados from './pages/Associados';
import Cardapio from './pages/pagesCardapio/Menu';
import SaldoLanchonete from './pages/SaldoLanchonete';
import FinanceiroClube from './pages/FinanceiroClube';
import Relatorios from './pages/Relatorios';
import HomeAssociados from './areaAssociados/HomeAssociados';
import CardapioLanchonete from './areaAssociados/CardapioLanchonete';
import Carteirinha from './areaAssociados/Carteirinha';
import Financeiro from './areaAssociados/Financeiro';
import SaldoLanchoneteAssociados from './areaAssociados/SaldoLanchoneteAssociados';
import Login from './pages/Login';
import HomeColaboradores from './areaColaboradores/HomeColaboradores';
import DebitarPedido from './areaColaboradores/DebitarPedido';
import AdicionarSaldo from './areaColaboradores/RecargaSaldo';
import Caixa from './areaColaboradores/Caixa';
import AppContext from './api/AppContext';
import Perfil from './areaAssociados/Perfil';
import AcompanharPedido from './areaAssociados/AcompanharPedido';

// // Protected Route component
// const ProtectedRoute = ({ children, requiredRole }) => {
//   // const user = JSON.parse(localStorage.getItem('user'));
//   const { user, isAuthenticated } = useContext(AppContext);
//   if (!user || !user.role) {
//     return <Navigate to="/login" replace />;
//   }

//   if (requiredRole && user.role !== requiredRole) {
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// };
// Protected Route component
const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, isAuthenticated } = useContext(AppContext);
  
  // Verificação de autenticação
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Aguarda carregamento do user
  if (!user) {
    return <div>Carregando...</div>; // ou um spinner
  }

  // Verificação de roles
  if (requiredRole && user.role) {
    const allowedRoles = Array.isArray(requiredRole) 
      ? requiredRole 
      : [requiredRole];
    
    if (!allowedRoles.includes(user.role)) {
      return <Navigate to="/login" replace />;
    }
  }

  return children;
};

const AppRoutes = () => {
  // const user = JSON.parse(localStorage.getItem('user'));
  const { user, isAuthenticated } = useContext(AppContext);
  
  return (
    
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />
      <Route 
        path="/" 
        element={
          user && isAuthenticated ? (
            user.role === 'admin' ? (
              <Navigate to="/dashboard" replace />
            ) : user.role === 'member' ? (
              <Navigate to="/member/dashboard" replace />
            ) : user.role === 'staff' ? (
              <Navigate to="/staff/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      
      {/* Admin routes */}
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute requiredRole="admin">
            <TelaInicial />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/colaboradores" 
        element={
          <ProtectedRoute requiredRole="admin">
            <Colaboradores />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/associados" 
        element={
          <ProtectedRoute requiredRole="admin">
            <Associados />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/cardapio" 
        element={
          <ProtectedRoute requiredRole={["admin", "member", "staff"]}>
            <Cardapio />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/saldolanchonete" 
        element={
          <ProtectedRoute requiredRole="admin">
            <SaldoLanchonete />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/financeiroclube" 
        element={
          <ProtectedRoute requiredRole="admin">
            <FinanceiroClube />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/relatorios" 
        element={
          <ProtectedRoute requiredRole="admin">
            <Relatorios />
          </ProtectedRoute>
        } 
      />
       <Route 
        path="/servicoslanchonete" 
        element={
          <ProtectedRoute requiredRole="admin">
            <HomeColaboradores />
          </ProtectedRoute>
        } 
      />
       <Route 
        path="/enviarpedido" 
        element={
          <ProtectedRoute requiredRole={["admin", "staff", "member"]}>
            <DebitarPedido />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/staff/adicionar-saldo" 
        element={
          <ProtectedRoute requiredRole={["admin", "staff"]}>
            <AdicionarSaldo />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/staff/caixa" 
        element={
          <ProtectedRoute requiredRole={["admin", "staff"]}>
            <Caixa />
          </ProtectedRoute>
        } 
      />
      
      {/* member routes */}
      <Route 
        path="/member/dashboard" 
        element={
          <ProtectedRoute requiredRole="member">
            <HomeAssociados />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/member/carteirinha" 
        element={
          <ProtectedRoute requiredRole="member">
            <Carteirinha />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/member/financeiro" 
        element={
          <ProtectedRoute requiredRole="member">
            <Financeiro />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/member/saldo" 
        element={
          <ProtectedRoute requiredRole="member">
            <SaldoLanchoneteAssociados />
          </ProtectedRoute>
        } 
      />

      <Route 
        path="/member/acompanhar-pedido" 
        element={
          <ProtectedRoute requiredRole="member">
            <AcompanharPedido />
          </ProtectedRoute>
        } 
      />

      <Route 
        path="/member/perfil" 
        element={
          <ProtectedRoute requiredRole="member">
            <Perfil />
          </ProtectedRoute>
        } 
      />
      
      {/* Staff routes */}
      <Route 
        path="/staff/dashboard" 
        element={
          <ProtectedRoute requiredRole="staff">
            <HomeColaboradores />
          </ProtectedRoute>
        } 
      />
      
      {/* Fallback routes */}
      <Route path="/unauthorized" element={<div>Acesso não autorizado</div>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;